const PDP_SELECTED_OPTIONS = 'pdp_selected_options'
const PDP_SELECTED_VARIANT_ID = 'pdp_selected_variant_id'
const KLAVIYO_SELECTED_OPTIONS = 'klaviyo_selected_options'

class PDPHandler {
	constructor() {
		this.options = {}
		this.selectedOptions = {}
		this.product = {}
		this.useLocalStorage = true
	}

	// ------------------------------------------------------------ getters
	get productOptionsLength() {
		return this.product.options?.length || Number(this.product.option_size) || 0
	}

	get productOptionsEl() {
		return document.querySelector('#product-options')
	}

	get addButtonEl() {
		return document.querySelector('#add-to-cart')
	}

	get notifyMeButtonEl() {
		return document.querySelector('#notify-me-btn')
	}

	get stickyAddButtonEl() {
		return document.querySelector('#sticky-add-cart')
	}

	get stickyNotifyMeButtonEl() {
		return document.querySelector('#sticky-notify-me-btn')
	}

	get shopifyPaymentButtonEl() {
		return document.querySelector('.shopify-payment-button')
	}

	// ------------------------------------------------------------ setters
	set setProduct(product) {
		this.product = product
	}

	set setUseLocalStorage(useLocalStorage) {
		this.useLocalStorage = useLocalStorage
	}

	// ------------------------------------------------------------ methods
	init(product) {
		if (product) {
			this.setProduct = product
			this.optionsAddEventListener()
			this.handleOptionsFromLocalStorage()
			this.handleIsOnlyOneOption()
			this.handleReviewStarsClick()
		} else {
			console.error('ERROR: PDPHandler -> init() method: product undefined')
		}
	}

	handleIsOnlyOneOption() {
		const inputEls = this.productOptionsEl.querySelectorAll('.input-option')

		if (inputEls.length === 1) inputEls[0].click()
	}

	handleReviewStarsClick() {
		const reviewsWidgetEl =
			document.querySelector('.okeReviews-parent-reviewsWidget .okeReviews-widgetNavBar') ||
			document.querySelector('.okeReviews .oke-w-controls-nav')
		const reviewStarsEls = document.querySelectorAll('.PDP-okeReviews-productRatingSummary.review-count')

		if (!reviewsWidgetEl || !reviewStarsEls.length) return

		reviewStarsEls.forEach(el => {
			el.addEventListener('click', function() {
				reviewsWidgetEl.scrollIntoView({
					behavior: 'smooth',
					block: 'start'
				})
			})
		})
	}

	optionsAddEventListener() {
		this.productOptionsEl.querySelectorAll('.input-option')?.forEach(option => {
			option.addEventListener('change', e => {
				this.setOptionInLocalStorage(e.currentTarget)
				this.setOption(e.currentTarget)
			})
		})
	}

	setOptionInLocalStorage(currentTarget) {
		if (!this.useLocalStorage) return

		const optionName = currentTarget.getAttribute('name')
		const value = currentTarget.value

		const initOption = {
			optionName,
			value
		}
		this.selectedOptions[initOption.optionName] = value
		localStorage.setItem(KLAVIYO_SELECTED_OPTIONS, JSON.stringify(this.selectedOptions));

		let selectedProductOptions = this.getPDPSelectedOptions()

		if (selectedProductOptions) {
			const modifyProperty = (arr, optionName, value) => {
				const targetObj = arr.find(obj => obj.optionName === optionName)

				if (targetObj) targetObj.value = value
				else selectedProductOptions.push(initOption)
			}

			modifyProperty(selectedProductOptions, initOption.optionName, initOption.value)
		} else selectedProductOptions = [initOption]

		this.setPDPSelectedOptions(selectedProductOptions)
		this.pushToKlaviyo(selectedProductOptions)
	}

	handleOptionsFromLocalStorage() {
		if (!this.useLocalStorage) return

		const selectedProductOptions = this.getPDPSelectedOptions()

		if (selectedProductOptions) {
			selectedProductOptions.forEach(o => this.setOptionFromLocalStorage(o))
		} else {
			this.setOptionFromLocalStorage({ optionName: 'length', value: 'Regular' }) // default value
		}
	}

	setOption(currentTarget) {
		const value = currentTarget.value
		const position = currentTarget.getAttribute('data-option-position')

		const selectedSpan = this.productOptionsEl.querySelector(`span[data-selected-postion="${position}"]`)
		if (selectedSpan) selectedSpan.innerText = value

		this.options[`option${position}`] = value

		this.checkSwatchAvailable()
		this.checkSoldout()
		this.checkSelectedAllOptions()
		this.handleHideSubscriptionForProductSizesArr()
	}

	setOptionFromLocalStorage(productVariant) {
		const value = productVariant.value
		const optionName = productVariant.optionName
		const input = document.querySelector(`input[value="${value}"][name="${optionName}"]`)

		if (input) {
			const position = input.getAttribute('data-option-position')
			input.checked = true

			const selectedSpan = this.productOptionsEl.querySelector(`span[data-selected-postion="${position}"]`)
			if (selectedSpan) selectedSpan.innerText = value

			this.options[`option${position}`] = value;
			this.selectedOptions[optionName] = value;
			localStorage.setItem(KLAVIYO_SELECTED_OPTIONS, JSON.stringify(this.selectedOptions));

			this.checkSwatchAvailable()
			this.checkSoldout()
			this.checkSelectedAllOptions()
			this.handleHideSubscriptionForProductSizesArr()
		}
	}

	handleHideSubscriptionForProductSizesArr() {
		const sizeInput = document.querySelector('input[name="size"]:checked')
		const lengthInput = document.querySelector('input[name="length"]:checked')
		const frequencyEl = document.querySelector('.subscription_frequancy')
		const hiddenOptions = this.product.hide_subscription_for_options || []

		if (!frequencyEl || hiddenOptions.length === 0) return

		const selectedValues = [sizeInput?.value, lengthInput?.value]
			.filter(Boolean)
			.map(v => v.toLowerCase())

		const isHidden = hiddenOptions.some(opt =>
			selectedValues.includes(opt.label?.toLowerCase())
		)

		frequencyEl.style.display = isHidden ? 'none' : 'block'
		frequencyEl.classList.toggle('subscription-blocked', isHidden)
	}

	checkSoldout() {
		this.productOptionsEl.querySelectorAll('.input-option')?.forEach(option => {
			const initOptions = { ...this.options }

			const value = option.value
			const position = option.getAttribute('data-option-position')

			initOptions[`option${position}`] = value

			const variantFiltered = this.productVariantsHandler(initOptions, this.product, 'filter')

			if (variantFiltered.length) {
				const available = variantFiltered.some(e => e.available)

				if (available) {
					option.parentElement.classList.remove('soldout')
					option.parentElement.classList.add('available')
				} else {
					option.parentElement.classList.remove('available')
					option.parentElement.classList.add('soldout')
				}
			}
		})
	}

	checkSwatchAvailable() {
		window.productsArray?.forEach(product => {
			const initOptions = { ...this.options }
			const variantFiltered = this.productVariantsHandler(initOptions, product, 'filter')

			if (variantFiltered) {
				const available = variantFiltered.some(e => e.available)
				const swatchBoxEl = document.querySelector(`.swatch_box[handle="${product.handle}"]`)

				if (!swatchBoxEl) return

				swatchBoxEl.classList[available ? 'remove' : 'add']("size-not-available")
			}
		})

		this.checkSwatchAvailableForBlock()
	}

	checkSwatchAvailableForBlock() {
		const swatchesEls = document.querySelectorAll('#product-template li.swatches')

		if (!swatchesEls.length) return

		swatchesEls.forEach(s => {
			const swatchBoxEls = s.querySelectorAll('.swatch_box')
			const swatchBoxSizeNotAvailableEls = s.querySelectorAll('.swatch_box.size-not-available')

			s.style.display = swatchBoxEls.length === swatchBoxSizeNotAvailableEls.length ? 'none' : 'list-item'
		})
	}

	checkSelectedAllOptions() {
		const optionsLength = Object.keys(this.options).length

		if (this.productOptionsLength <= optionsLength) this.getVariant()
	}

	getVariant() {
		const variant = this.productVariantsHandler(this.options, this.product, 'find')

		this.handleButtons(variant)
		this.setPDPVariantIdInSessionStorage(variant)
		this.setPDPVariantIdInUrlParam(variant)
		this.setAvailabilityJSONSchema(variant)
		this.setProductVariantIdForShopPay(variant)
	}

	handleButtons(variant = {}) {
		if (this.addButtonEl?.getAttribute('data-is-expired')) return

		if (variant.available) {
			if (this.addButtonEl) this.addButtonEl.innerText = 'Add To Cart'
			if (this.addButtonEl) this.addButtonEl.removeAttribute('disabled')
			if (this.addButtonEl) this.addButtonEl.style.display = 'block'
			if (this.notifyMeButtonEl) this.notifyMeButtonEl.style.display = 'none'

			if (this.stickyAddButtonEl) this.stickyAddButtonEl.innerText = 'Add To Cart'
			if (this.stickyAddButtonEl) this.stickyAddButtonEl.setAttribute('data-select-options-mode', 'false')
			if (this.stickyAddButtonEl) this.stickyAddButtonEl.style.display = 'block'
			if (this.stickyNotifyMeButtonEl) this.stickyNotifyMeButtonEl.style.display = 'none'

			if (this.shopifyPaymentButtonEl) this.shopifyPaymentButtonEl.classList.remove('disabled')
		} else {
			if (this.addButtonEl) this.addButtonEl.setAttribute('disabled', 'disabled')
			if (this.addButtonEl) this.addButtonEl.style.display = 'none'
			if (this.notifyMeButtonEl) this.notifyMeButtonEl.style.display = 'block'

			if (this.stickyAddButtonEl) this.stickyAddButtonEl.setAttribute('data-select-options-mode', 'true')
			if (this.stickyAddButtonEl) this.stickyAddButtonEl.style.display = 'none'
			if (this.stickyNotifyMeButtonEl) this.stickyNotifyMeButtonEl.style.display = 'block'

			if (this.shopifyPaymentButtonEl) this.shopifyPaymentButtonEl.classList.add('disabled')

			this.handleNotifyMeModal(variant)
		}
	}

	handleNotifyMeModal(variant = {}) {
		const notifyMeVarInput = document.querySelector('#notify-me-variant-id')
		const modalNotifyVariant =  document.querySelector('#modal-notify-variant')

		if (notifyMeVarInput) notifyMeVarInput.value = variant.id
		if (modalNotifyVariant) modalNotifyVariant.innerText = variant.option_text || ''
	}

	pushToKlaviyo() {
		const customerEmail = window.customerEmail

		if (customerEmail) {
			const klaviyoService = klaviyo || []

			klaviyoService.push(['identify', {
				'$email' : customerEmail
			}])

			const product = window.productItem;
			product.selectedOptions = JSON.parse(localStorage.getItem(KLAVIYO_SELECTED_OPTIONS));
			window.productItem = product;

			klaviyoService.push(['track', 'Viewed Product', product])
			klaviyoService.push(['trackViewedItem',
				{
					"Title": product.name,
					"ItemId": product.ProductID,
					"Categories": product.Categories,
					"ImageUrl": product.ImageURL,
					"Url": product.URL,
					"Metadata": {
						"Brand": product.Brand,
						"Price": product.Price,
						"CompareAtPrice": product.CompareAtPrice,
					}
				}
			])
			var atcButtons = document.querySelectorAll("form[action*='/cart/add'] button[type='submit']");
			for (var i = 0; i < atcButtons.length; i++) {
				atcButtons[i].addEventListener("click", function() {
					const product = window.productItem;
					klaviyoService.push(['track', 'Added to Cart', product]);
				})
			} 
		}
	}

	productVariantsHandler(initOptions, product, method) {
		const variants = product.variants

		if (!initOptions || !variants) return false

		return variants[method](variant => {
			// checking for out of stock when if first option is not selected
			const optionsKeys = Object.keys(initOptions)

			if (optionsKeys.length === 1 || this.productOptionsLength === 1) {
				const optionKey = optionsKeys[0]
				return variant[optionKey] === initOptions[optionKey]
			}

			let result = false

			if (initOptions['option1']) {
				result = this.handleVariant(variant.option1) === initOptions['option1']
			}

			if (initOptions['option1'] && initOptions['option2']) {
				result =
					this.handleVariant(variant.option1) === initOptions['option1'] &&
					this.handleVariant(variant.option2) === initOptions['option2']
			}

			if (initOptions['option1'] && initOptions['option2'] && initOptions['option3']) {
				result =
					this.handleVariant(variant.option1) === initOptions['option1'] &&
					this.handleVariant(variant.option2) === initOptions['option2'] &&
					this.handleVariant(variant.option3) === initOptions['option3']
			}

			return result
		})
	}

	handleVariant(variant) {
		return variant?.replace('\"', '')
	}

	getPDPSelectedOptions() {
		return JSON.parse(localStorage.getItem(PDP_SELECTED_OPTIONS))
	}

	setPDPSelectedOptions(options = null) {
		localStorage.setItem(PDP_SELECTED_OPTIONS, JSON.stringify(options))
	}

	setPDPVariantIdInSessionStorage(variant = {}) {
		if (variant.available) sessionStorage.setItem(PDP_SELECTED_VARIANT_ID, variant.id)
	}

	setPDPVariantIdInUrlParam(variant = {}) {
		if (!variant.available) return

		const url = new URL(window.location.href)

		const otherParams = Array.from(url.searchParams.entries())
			.filter(([key]) => key !== 'variant')

		otherParams.unshift(['variant', variant.id])

		url.search = new URLSearchParams(otherParams).toString()

		window.history.replaceState({}, '', url)
	}

	setAvailabilityJSONSchema(variant = {}) {
		const scriptEl = document.querySelector('script#json-schema-org')

		if (!scriptEl) return

		const json = scriptEl.innerHTML
		const obj = JSON.parse(json)

		if (obj?.offers?.availability) {
			obj.offers.availability = variant.available ? 'InStock' : 'OutOfStock'
			scriptEl.innerHTML = JSON.stringify(obj)
		}
	}

	setProductVariantIdForShopPay(variant = {}) {
		const inputEl = document.querySelector('#product-variant-id')
		if (inputEl) inputEl.value = variant.id
	}
}

const FctApp = window.FctApp;
FctApp.PDPHandler = new PDPHandler();
